import { useParams } from 'react-router-dom'
import { useMangaList, useMeta } from '../api/useManga'
import MangaGrid from '../components/manga/MangaGrid'

export default function Genre() {
  const { slug } = useParams()
  const { data, isLoading } = useMangaList({ genre: slug, limit: 48 })
  const { data: meta } = useMeta()
  const items = data?.items || data || []
  const genreTitle = meta?.genres?.find((g) => g.code === slug)?.name || slug

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8">
      <title>{genreTitle} — манга онлайн | {import.meta.env.VITE_SITE_NAME}</title>
      <meta name="description" content={`Читайте мангу в жанре «${genreTitle}» онлайн на русском языке на ${import.meta.env.VITE_SITE_NAME}.`} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={import.meta.env.VITE_SITE_NAME} />
      <meta property="og:title" content={`${genreTitle} — манга онлайн | ${import.meta.env.VITE_SITE_NAME}`} />
      <meta property="og:description" content={`Читайте мангу в жанре «${genreTitle}» онлайн на русском языке на ${import.meta.env.VITE_SITE_NAME}.`} />
      <link rel="canonical" href={`${window.location.origin}/genre/${slug}`} />
      <div className="mb-8">
        <h1 className="text-2xl font-black">{genreTitle}</h1>
        {items.length > 0 && <p className="text-sm mt-1 text-muted">{items.length} тайтлов</p>}
      </div>
      <MangaGrid items={items} loading={isLoading} count={24} />
    </div>
  )
}
